import { Route, Switch } from 'react-router-dom'

import { CreateActionPage } from '../containers/Actions/pages/createActions'
import { ListActionsPage } from '../containers/Actions/pages/listActions'
import ListCalendar from '../containers/Actions/pages/listCalendar/ShowCalendar'
import ListTimeline from '../containers/Actions/pages/listTimeline/ShowTimeline'
import ActionsPlan from '../containers/ActionsPlan/ActionsPlan'
import ListActionsPlan from '../containers/ActionsPlan/ListActionsPlan'
import ListActionTypesJSON from '../containers/ActionTypes/ActionTypesJSON/ActionTypesJSON'
import CreateActionTypes from '../containers/ActionTypes/pages/createActionType'
import ListActionTypes from '../containers/ActionTypes/pages/listActionTypes'
import ListAlternativeWallet from '../containers/AlternativeWallet/ListAlternativeWallet'
import CreateBrand from '../containers/Brand/CreateBrand'
import ListBrand from '../containers/Brand/ListBrand'
import CreateBusinessArea from '../containers/BusinessArea/CreateBusinessArea'
import ListBusinessArea from '../containers/BusinessArea/ListBusinessArea'
import CreateCategory from '../containers/Category/CreateCategory'
import ListCategory from '../containers/Category/ListCategory'
import CreateCategoryAction from '../containers/CategoryAction/CreateCategoryAction'
import CreateConfiguration from '../containers/Configuration/CreateConfiguration'
import CreateContacts from '../containers/Contacts/CreateContacts'
import ListContacts from '../containers/Contacts/ListContacts'
import CreateCustomer from '../containers/customer/CreateCustomer'
import CreateCustomerLocation from '../containers/customer/CreateLocation'
import ListCustomer from '../containers/customer/ListCustomers/ListCustomer'
import ListCustomerLocation from '../containers/customer/ListLocations'
import CreateCustomerTypes from '../containers/customerTypes/CreateCustomerTypes'
import ListCustomerTypes from '../containers/customerTypes/ListCustomerTypes'
import CreateCustomerWallet from '../containers/CustomerWallet/CreateCustomerWallet'
import ListCustomerWallet from '../containers/CustomerWallet/ListCustomerWallet'
import Dashboard from '../containers/Dashboard/dashboard'
import CreateDataLoads from '../containers/DataLoad/CreateDataLoad'
import ImportationStatus from '../containers/DataLoad/ImportationStatus'
import ListDataLoads from '../containers/DataLoad/ListDataLoads'
import CreateDistrict from '../containers/District/CreateDistrict'
import ListDistrict from '../containers/District/ListDistrict'
import FarmersPortalDashboard from '../containers/FarmersPortal/Dashboard'
import Importation from '../containers/Importation/Importation'
import CreateJourneys from '../containers/Journeys/CreateJourneys'
import ListJourneys from '../containers/Journeys/ListJourneys'
import CreateLocationType from '../containers/LocationType/CreateLocationType'
import ListLocationType from '../containers/LocationType/ListLocationType'
import CreateMaterials from '../containers/Material/CreateMaterials'
import ListMaterials from '../containers/Material/ListMaterials'
import CreateMember from '../containers/Members/CreateMember'
import ListMember from '../containers/Members/ListMember'
import CreateMemberType from '../containers/MemberType/CreateMemberType'
import ListMemberType from '../containers/MemberType/ListMemberType'
import CreateOrganization from '../containers/Organization/CreateOrganization'
import ListOrganization from '../containers/Organization/ListOrganization'
import CreateOrganizationTypes from '../containers/OrganizationTypes/CreateOrganizationTypes'
import ListOrganizationTypes from '../containers/OrganizationTypes/ListOrganizationTypes'
import ListPermissions from '../containers/Permissions/ListPermissions'
import UpdatePermissions from '../containers/Permissions/UpdatePermissions'
import CreateProfile from '../containers/Profile/CreateProfile'
import EditProfile from '../containers/Profile/EditProfile'
import CreateReferencePeriod from '../containers/ReferencePeriod/CreateReferencePeriod'
import ListReferencePeriod from '../containers/ReferencePeriod/ListReferencePeriod'
import CreateRegion from '../containers/Region/CreateRegion'
import ListRegion from '../containers/Region/ListRegion'
import Reports from '../containers/Reports/Reports'
import CreateTeam from '../containers/Team/CreateTeam'
import ListTeam from '../containers/Team/ListTeam'
import CreateOrEditTopConsultantsType from '../containers/TopConsultantsTypes/CreateOrEditTopConsultantsType'
import ListTopConsultantsTypes from '../containers/TopConsultantsTypes/ListTopConsultantsTypes'
import CreateTypes from '../containers/Types/CreateTypes'
import ListTypes from '../containers/Types/ListTypes'

const App = ({ match }) => (
  <div className="gx-main-content-wrapper">
    <Switch>
      <Route path={`${match.url}dashboard`} component={Dashboard} />
      <Route path={`${match.url}reports`} component={Reports} />

      <Route path="/customerTypes/create" component={CreateCustomerTypes} />
      <Route path="/customerTypes/list" component={ListCustomerTypes} />
      <Route path="/customerTypes/:id" component={CreateCustomerTypes} />

      <Route path="/customer/create" component={CreateCustomer} />
      <Route path="/customer/list" component={ListCustomer} />
      <Route path="/customer/:id/locations-create" component={CreateCustomerLocation} />
      <Route path="/customer/:id/locations" component={ListCustomerLocation} />
      <Route path="/customer/:id/:idLocation" component={CreateCustomerLocation} />
      <Route path="/customer/:id" component={CreateCustomer} />

      <Route path="/customerWallet/create" component={CreateCustomerWallet} />
      <Route path="/customerWallet/list" component={ListCustomerWallet} />
      <Route path="/customerWallet/:id" component={CreateCustomerWallet} />

      <Route path="/alternativeWallet/list" component={ListAlternativeWallet} />

      <Route path="/memberTypes/create" component={CreateMemberType} />
      <Route path="/memberTypes/list" component={ListMemberType} />
      <Route path="/memberTypes/:id" component={CreateMemberType} />

      <Route path="/types/:type/create" component={CreateTypes} />
      <Route path="/types/:type/list" component={ListTypes} />
      <Route path="/types/:type/:id" component={CreateTypes} />

      <Route path="/organizationTypes/create" component={CreateOrganizationTypes} />
      <Route path="/organizationTypes/list" component={ListOrganizationTypes} />
      <Route path="/organizationTypes/:id" component={CreateOrganizationTypes} />

      <Route path="/brand/create" component={CreateBrand} />
      <Route path="/brand/list" component={ListBrand} />
      <Route path="/brand/:id" component={CreateBrand} />

      <Route path="/businessArea/create" component={CreateBusinessArea} />
      <Route path="/businessArea/list" component={ListBusinessArea} />
      <Route path="/businessArea/:id" component={CreateBusinessArea} />

      <Route path="/contacts/create" component={CreateContacts} />
      <Route path="/contacts/list" component={ListContacts} />
      <Route path="/contacts/:id" component={CreateContacts} />

      <Route path="/organization/create" component={CreateOrganization} />
      <Route path="/organization/list" component={ListOrganization} />
      <Route path="/organization/:id" component={CreateOrganization} />

      <Route path="/district/create" component={CreateDistrict} />
      <Route path="/district/list" component={ListDistrict} />
      <Route path="/district/:id" component={CreateDistrict} />

      <Route path="/region/create" component={CreateRegion} />
      <Route path="/region/list" component={ListRegion} />
      <Route path="/region/:id" component={CreateRegion} />

      <Route path="/referencePeriod/create" component={CreateReferencePeriod} />
      <Route path="/referencePeriod/list" component={ListReferencePeriod} />
      <Route path="/referencePeriod/:id" component={CreateReferencePeriod} />

      <Route path="/member/create" component={CreateMember} />
      <Route path="/member/list" component={ListMember} />
      <Route path="/member/:id" component={CreateMember} />

      <Route path="/actions/calendar" component={ListCalendar} />
      <Route path="/actions/timeline" component={ListTimeline} />

      <Route path="/actions/create" component={CreateActionPage} />
      <Route path="/actions/list" component={ListActionsPage} />
      <Route path="/actions/:actionTypeId/:id" component={CreateActionPage} />

      <Route path="/actionTypes/create" component={CreateActionTypes} />
      <Route path="/actionTypes/list" component={ListActionTypes} />
      <Route path="/actionTypesjson/list" component={ListActionTypesJSON} />
      <Route path="/actionTypes/:id" component={CreateActionTypes} />
      <Route path="/actionTypesjson/list" component={ListActionTypesJSON} />

      <Route path="/journeys/create" component={CreateJourneys} />
      <Route path="/journeys/list" component={ListJourneys} />
      <Route path="/journeys/:id" component={CreateJourneys} />

      <Route path="/permissions/list" component={ListPermissions} />
      <Route path="/permissions/:id" component={UpdatePermissions} />

      <Route path="/team/create" component={CreateTeam} />
      <Route path="/team/list" component={ListTeam} />
      <Route path="/team/:id" component={CreateTeam} />

      <Route path="/configuration" component={CreateConfiguration} />

      <Route path="/importation/" component={Importation} />

      <Route path="/materials/create" component={CreateMaterials} />
      <Route path="/materials/list" component={ListMaterials} />
      <Route path="/materials/:id" component={CreateMaterials} />

      <Route path="/profiles/create" component={CreateProfile} />
      <Route path="/profiles" component={EditProfile} />

      <Route path="/farmerPortal/dashboard" component={FarmersPortalDashboard} />

      <Route path="/category/list" component={ListCategory} />
      <Route path="/category/:id?" component={CreateCategory} />
      <Route path="/categoryAction/:id?" component={CreateCategoryAction} />

      <Route path="/dataload" component={ListDataLoads} />
      <Route path="/createDataLoads" component={CreateDataLoads} />
      <Route path="/importationStatus" component={ImportationStatus} />

      <Route path="/actionsPlan/list" component={ListActionsPlan} />
      <Route path="/actionsPlan/:id" component={ActionsPlan} />

      <Route path="/locationTypes/create" component={CreateLocationType} />
      <Route path="/locationTypes/list" component={ListLocationType} />
      <Route path="/locationTypes/:id" component={CreateLocationType} />

      <Route path="/topConsultantsTypes/list" component={ListTopConsultantsTypes} />
      <Route path="/topConsultantsTypes/create" component={CreateOrEditTopConsultantsType} />
      <Route path="/topConsultantsTypes/:id" component={CreateOrEditTopConsultantsType} />
    </Switch>
  </div>
)

export default App
